import React, { useMemo, useState } from 'react'
import ClassLayout from './ClassLayout/ClassLayout'
import CallScreen from './CallScreen/CallScreen'
import EndClassModal from './Modals/EndClassModal'
import ThanksModal from './Modals/ThanksModal'

const ClassPage = () => {
  return (
    <ClassLayout>
      {/* <ThanksModal />
      <EndClassModal /> */}
      <CallScreen />
    </ClassLayout>
  )
}

export default ClassPage
